import { render, staticRenderFns } from "./QuizBrag.vue?vue&type=template&id=871f938a&scoped=true&"
import script from "./QuizBrag.vue?vue&type=script&lang=js&"
export * from "./QuizBrag.vue?vue&type=script&lang=js&"
import style0 from "./QuizBrag.vue?vue&type=style&index=0&id=871f938a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871f938a",
  null
  
)

export default component.exports